import { createContext, useState } from "react";

export const GeneralDataContext = createContext();

export const GeneralDataProvider = (props) => {
    const [financialData, setFinancialData] = useState(null);
    const [numberOfHubs, setNumberOfHubs] = useState(null);

    return (
        <GeneralDataContext.Provider
            value={{
                financialPage: { financialData, setFinancialData },
                expandTable: { numberOfHubs, setNumberOfHubs },
            }}
        >
            {props.children}
        </GeneralDataContext.Provider>
    );
};
